let currentPage = 2;
let isLoading = false;
let noMoreProductsShown = false;

const SCROLL_STORAGE_KEY = 'zebaqCollectionScrollState';

// =====================================================
// SAVE PRODUCT POSITION (+ full grid snapshot)
// =====================================================


document.addEventListener('click', function (event) {

  const productLink = event.target.closest('a[href*="/products/"]');

  if (!productLink) return;

  const productItem = productLink.closest('#product-grid .grid__item');

  if (!productItem) return;

  const productHandle = productItem.dataset.productHandle;

  if (!productHandle) return;

  const productGrid = document.getElementById('product-grid');

  const state = {
    collectionUrl: window.location.pathname + window.location.search,
    productHandle: productHandle,
    scrollY: window.scrollY,
    currentPage: currentPage,
    // NEW: poora loaded grid HTML save kar rahe hain
    gridHTML: productGrid ? productGrid.innerHTML : null,
    savedAt: Date.now()
  };

  try {
    sessionStorage.setItem(SCROLL_STORAGE_KEY, JSON.stringify(state));
  } catch (e) {

    console.warn('Could not save full snapshot, will fall back to fetch:', e);
    delete state.gridHTML;
    try {
      sessionStorage.setItem(SCROLL_STORAGE_KEY, JSON.stringify(state));
    } catch (e2) {
      console.warn('Snapshot save failed entirely:', e2);
    }
  }

  console.log('Collection position saved (with snapshot):', !!state.gridHTML);
});


// =====================================================
// RESTORE PRODUCT POSITION
// =====================================================

window.addEventListener('pageshow', function (event) {


  if (event.persisted) {
    console.log('Restored from bfcache — scroll already correct, skipping.');
    sessionStorage.removeItem(SCROLL_STORAGE_KEY);
    return;
  }

  restoreCollectionPosition();

});


// =====================================================
// RESTORE FUNCTION
// =====================================================

function restoreCollectionPosition() {

  const savedData = sessionStorage.getItem(SCROLL_STORAGE_KEY);

  if (!savedData) return;

  let state;

  try {
    state = JSON.parse(savedData);
  } catch (error) {
    console.error('Invalid scroll state:', error);
    sessionStorage.removeItem(SCROLL_STORAGE_KEY);
    return;
  }

  const currentUrl = window.location.pathname + window.location.search;

  if (state.collectionUrl !== currentUrl) {
    return;
  }

  console.log('Restoring collection position:', state);

  const productGrid = document.getElementById('product-grid');

  // ---------------------------------------------------

  // ---------------------------------------------------
  if (state.gridHTML && productGrid) {

    productGrid.innerHTML = state.gridHTML;

    currentPage = state.currentPage || 2;
    noMoreProductsShown = false;
    isLoading = false;


    if (typeof initVariantAndCartHandlers === 'function') {
      initVariantAndCartHandlers();
    }
    if (typeof applyCombinedFilters === 'function') {
      applyCombinedFilters();
    }

    const restoredProduct = findSavedProduct(state.productHandle);

    if (restoredProduct) {
      scrollToSavedProduct(restoredProduct);
    } else {

      window.scrollTo({ top: state.scrollY || 0, behavior: 'instant' });
    }

    sessionStorage.removeItem(SCROLL_STORAGE_KEY);
    return;
  }

  // ---------------------------------------------------

  // ---------------------------------------------------
  const existingProduct = findSavedProduct(state.productHandle);

  if (existingProduct) {
    scrollToSavedProduct(existingProduct);
    sessionStorage.removeItem(SCROLL_STORAGE_KEY);
    return;
  }

  loadPagesUntilProductFoundParallel(state);
}


// =====================================================
// FIND SAVED PRODUCT
// =====================================================

function findSavedProduct(productHandle) {

  if (!productHandle) return null;

  const products = document.querySelectorAll('#product-grid .grid__item');

  for (const product of products) {
    if (product.dataset.productHandle === productHandle) {
      return product;
    }
  }

  return null;
}


// =====================================================
// FALLBACK: LOAD PAGES IN PARALLEL (instead of one-by-one)
// =====================================================


function loadPagesUntilProductFoundParallel(state) {

  const maxPages = state.currentPage || 2;
  const productGrid = document.getElementById('product-grid');

  if (!productGrid) return;

  const pagesToFetch = [];
  for (let p = currentPage; p <= maxPages; p++) {
    pagesToFetch.push(p);
  }

  if (pagesToFetch.length === 0) {
    fallbackToScrollY(state);
    return;
  }

  const loader = document.getElementById('loading-indicator');
  if (loader) loader.style.display = 'block';

  const fetchPromises = pagesToFetch.map(page => {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set('page', page);
    const fullUrl = `${window.location.pathname}?${urlParams.toString()}`;

    return fetch(fullUrl)
      .then(response => {
        if (!response.ok) throw new Error(`HTTP error: ${response.status}`);
        return response.text();
      })
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        return {
          page,
          items: doc.querySelectorAll('#product-grid .grid__item')
        };
      })
      .catch(error => {
        console.error(`Error loading page ${page}:`, error);
        return { page, items: [] };
      });
  });

  Promise.all(fetchPromises).then(results => {


    results.sort((a, b) => a.page - b.page);

    let anyItemsAdded = false;

    results.forEach(result => {
      if (result.items.length > 0) {
        anyItemsAdded = true;
        result.items.forEach(item => productGrid.appendChild(item));
      }
    });

    currentPage = maxPages + 1;
    isLoading = false;

    if (loader) loader.style.display = 'none';

    if (typeof initVariantAndCartHandlers === 'function') {
      initVariantAndCartHandlers();
    }
    if (typeof applyCombinedFilters === 'function') {
      applyCombinedFilters();
    }

    const product = findSavedProduct(state.productHandle);

    if (product) {
      scrollToSavedProduct(product);
      sessionStorage.removeItem(SCROLL_STORAGE_KEY);
    } else {
      fallbackToScrollY(state);
    }
  });
}

function fallbackToScrollY(state) {
  console.log('Product not found. Restoring scroll position.');
  setTimeout(function () {
    window.scrollTo({ top: state.scrollY || 0, behavior: 'instant' });
    sessionStorage.removeItem(SCROLL_STORAGE_KEY);
  }, 100);
}


// =====================================================
// SCROLL TO PRODUCT
// =====================================================

function scrollToSavedProduct(product) {

  setTimeout(function () {

    product.scrollIntoView({
      behavior: 'instant',
      block: 'center'
    });

    setTimeout(function () {
      window.scrollBy({ top: -100, behavior: 'instant' });
    }, 50);

  }, 50); 

}


// =====================================================
// INFINITE SCROLL
// =====================================================

window.addEventListener('scroll', () => {

  const lastProduct = document.querySelector('#product-grid .grid__item:last-child');

  if (!lastProduct || isLoading || noMoreProductsShown) {
    return;
  }

  const rect = lastProduct.getBoundingClientRect();

  if (rect.bottom <= window.innerHeight + 20) {
    triggerLoadMore();
  }

});


// =====================================================
// TRIGGER LOADER
// =====================================================

function triggerLoadMore() {

  if (isLoading || noMoreProductsShown) {
    return;
  }

  isLoading = true;

  const loader = document.getElementById('loading-indicator');

  if (loader) {
    loader.style.display = 'block';
  }

  loadMoreProducts();

}


// =====================================================
// PRODUCT LOADER (normal single-page infinite scroll — unchanged)
// =====================================================

function loadMoreProducts(callback) {

  const urlParams = new URLSearchParams(window.location.search);

  urlParams.set('page', currentPage);

  const fullUrl = `${window.location.pathname}?${urlParams.toString()}`;

  fetch(fullUrl)

    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      return response.text();
    })

    .then(html => {

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newItems = doc.querySelectorAll('#product-grid .grid__item');
      const productGrid = document.getElementById('product-grid');

      if (newItems.length > 0) {

        newItems.forEach(item => {
          productGrid.appendChild(item);
        });

        if (typeof initVariantAndCartHandlers === 'function') {
          initVariantAndCartHandlers();
        }

        if (typeof applyCombinedFilters === 'function') {
          applyCombinedFilters();
        }

        currentPage++;
        isLoading = false;

        if (callback) {
          callback();
        } else {
          setTimeout(triggerLoadMore, 500);
        }

      } else {

        isLoading = false;

        const loader = document.getElementById('loading-indicator');
        if (loader) {
          loader.style.display = 'none';
        }

        const noMore = document.getElementById('no-more-products');
        if (noMore) {
          noMore.style.display = 'block';
        }

        noMoreProductsShown = true;

        if (callback) {
          callback();
        }
      }

    })

    .catch(error => {

      console.error('Error loading more products:', error);
      isLoading = false;

      const loader = document.getElementById('loading-indicator');
      if (loader) {
        loader.style.display = 'none';
      }

      if (callback) {
        callback();
      }
    });

}


// =====================================================
// COMBINED FILTER
// =====================================================

function applyCombinedFilters() {

  const selectedTags = Array.from(
    document.querySelectorAll('input[type="checkbox"]:checked')
  ).map(i => i.value.trim());

  const minInput =
    document.querySelector('.min-price-display') ||
    document.querySelector('.min-price');

  const maxInput =
    document.querySelector('.max-price-display') ||
    document.querySelector('.max-price');

  const minVal = parseInt(minInput?.value || "0");

  const maxVal = maxInput?.value ? parseInt(maxInput.value) : Infinity;

  const products = document.querySelectorAll('#product-grid .grid__item');

  const filterTagsContainer = document.getElementById('FilterTags');
  const appliedFiltersBox = document.getElementById('AppliedFilters');

  if (filterTagsContainer) {

    filterTagsContainer.innerHTML = '';

    selectedTags.forEach(tag => {
      const tagEl = document.createElement('span');
      tagEl.textContent = tag;
      tagEl.style =
        "background:#eee;padding:4px 10px;margin:4px;display:inline-block;border-radius:4px;";
      filterTagsContainer.appendChild(tagEl);
    });

  }

  if (appliedFiltersBox) {
    appliedFiltersBox.style.display = selectedTags.length > 0 ? 'block' : 'none';
  }

  products.forEach(p => {

    const productTags =
      p.getAttribute('data-tags')?.split(',').map(t => t.trim()) || [];

    const price = parseInt(p.getAttribute('data-price') || '0');

    const tagMatch =
      selectedTags.length === 0 || selectedTags.every(t => productTags.includes(t));

    const priceMatch = price >= minVal && price <= maxVal;

    p.style.display = (tagMatch && priceMatch) ? '' : 'none';

  });

}


// =====================================================
// CHECKBOX FILTERS
// =====================================================

document.querySelectorAll('input[type="checkbox"]').forEach(input => {

  input.addEventListener('change', () => {
    currentPage = 2;
    noMoreProductsShown = false;
    applyCombinedFilters();
    triggerLoadMore();
  });

});


// =====================================================
// PRICE FILTERS
// =====================================================

document
  .querySelectorAll('.min-price, .max-price, .min-price-display, .max-price-display')
  .forEach(input => {

    input.addEventListener('change', () => {

      const loader = document.getElementById('loading-indicator');
      if (loader) {
        loader.style.display = 'block';
      }

      currentPage = 2;
      noMoreProductsShown = false;

      const productGrid = document.getElementById('product-grid');
      if (productGrid) {
        productGrid.innerHTML = '';
      }

      function loadAllPages() {
        loadMoreProducts(() => {
          if (!noMoreProductsShown) {
            loadAllPages();
          } else {
            applyCombinedFilters();
            if (loader) {
              loader.style.display = 'none';
            }
          }
        });
      }

      isLoading = false;
      loadAllPages();

    });

  });